import React from 'react';
import { Link, browserHistory } from 'react-router';
import { Toastr } from 'modules/toastr';
import {InputPassword} from 'components/tt-forms/common';
import { User } from 'api';
import {MasterLayout} from 'layout';

class ChangePassword extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      currentPassword: '',
      password: '',
      passwordConfirmation: ''
    };
  }

  componentDidMount() {

  }

  handleChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    })
    return pass;
  }

  closeChangePassword() {
    browserHistory.push('/');
  }

  handleChangePassword() {
    if (this.validateSubmitForm()) {
      if (this.state.password != this.state.passwordConfirmation) {
        Toastr('Xác nhận mật khẩu không đúng.', 'error');
      } else {
        let params = {
          oldPassword: this.state.currentPassword,
          newPassword: this.state.password,
          newPasswordAgain: this.state.passwordConfirmation
        }
        User.actions.changePassword.request(null, params).then(res => {
          Toastr('Đổi mật khẩu thành công.', 'success');
          browserHistory.push('/');
        }).catch( (error) => {
          this.setState({loading: false});
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
          }
        });
      }
    }
  }

  componentWillUnmount() {

  }


  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container" ref="tcdTX">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Thay đổi mật khẩu</p>
            </div>
          </div>
          <form className="formChangePassword" noValidate>
            <div className="bottom-content">
                <div className="wrap-block pl15 pr15 pt20">
                  <div className="row pl10 pr10">
                    <InputPassword className="cp-input col-40" label="Mật khẩu cũ" value={this.state.currentPassword} onChange={this.handleChange.bind(this, 'currentPassword')} name="currentPassword" channel="formTaoDon" require bindValidator={this} placeholder="Nhập..."/>
                  </div>
                  <div className="row pl10 pr10">
                    <InputPassword className="cp-input col-40" label="Mật khẩu mới" value={this.state.password} onChange={this.handleChange.bind(this, 'password')} name="password" channel="formTaoDon" require bindValidator={this} placeholder="Nhập..."/>
                  </div>
                  <div className="row pl10 pr10">
                    <InputPassword className="cp-input col-40" label="Xác nhận mật khẩu mới" value={this.state.passwordConfirmation} onChange={this.handleChange.bind(this, 'passwordConfirmation')} bindValidator={this} name="passwordConfirmation" channel="formTaoDon" require placeholder="Nhập..."/>
                  </div>
                </div>
            </div>
            <div className="mt30 mb30">
              <div className="box-bottom">
                <Link className="btn-action btn-close" onClick={this.closeChangePassword.bind(this)}>
                  <span>Đóng</span>
                </Link>
                <Link className="btn-action btn-save" onClick={this.handleChangePassword.bind(this)}><span>Lưu</span></Link>
              </div>
            </div>
          </form>
        </div>
      </MasterLayout>
    );
  }
}

ChangePassword.defaultProps = {
  validators: {
    formTaoDon: []
  },
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/modules/change-password/ChangePassword.jsx